import styled from 'styled-components';

const HeaderContainer = styled.section`
  border-radius: ${({ theme }) => theme.spacing(12, 12, 0, 0)};
  background-color: ${({ theme }) => theme.colors.white};
`;

export default HeaderContainer;
